import { Table as MuiTable, TableHead, TableProps, TableRow } from '@mui/material';
import {
  createContext,
  CSSProperties,
  forwardRef,
  memo,
  PropsWithChildren,
  ReactNode,
  useContext,
  useState,
} from 'react';
import { useTableStyles } from './styles';

import TableHeader, { TableHeaderProps } from './TableHeader';

export const TablePropsContext = createContext<{
  table: Partial<TableProps>;
  tHead: TableHeaderProps;
  extraContent?: ReactNode;

  hideColumnHeader?: boolean;
}>({
  table: {},
  tHead: {
    hasSubRow: false,
    orderedColumns: [],
  },

  hideColumnHeader: false,
});
const VirtualTable = forwardRef<HTMLTableElement, PropsWithChildren<{ style: CSSProperties }>>(
  ({ children, ...props }, ref) => {
    const {
      table: tableProps,
      tHead: tHeadProps,
      extraContent,
      hideColumnHeader = false,
    } = useContext(TablePropsContext);
    const classes = useTableStyles();
    const [tableHeaderHeight, setTableHeaderHeight] = useState(0);

    return (
      <>
        <div
          ref={ref}
          {...props}
          style={{
            ...(props.style ?? {}),
            height: props.style?.height
              ? Number(props.style?.height) + tableHeaderHeight
              : undefined,
          }}
        >
          <MuiTable
            stickyHeader
            {...tableProps}
            style={{ ...tableProps.style, position: 'absolute', width: '100%' }}
            className={classes.tableDrag}
          >
            {!hideColumnHeader && (
              <TableHead>
                <TableRow>
                  <TableHeader
                    {...tHeadProps}
                    setTableHeaderHeight={setTableHeaderHeight}
                    tableHeaderHeight={tableHeaderHeight}
                  />
                </TableRow>
              </TableHead>
            )}
            {children}
            {extraContent}
          </MuiTable>
        </div>
      </>
    );
  }
);

export default memo(VirtualTable);
